/* Click Fencing - stop aluminium and mesh quotes charging GLASS SPIGOTS.
 *
 * Found 2026-09-01 while checking a 3-section flat top plan. Spigots are a FRAMELESS GLASS
 * component - core-drill spigots that clamp a glass panel. Blade, flat top and PerfMesh are
 * post-and-bracket systems: their posts and bracket packs are already billed per section.
 *
 * MEASURED, flat top, three sections 7300 / 5000 / 3000, no gates:
 *     quote shown to the customer   $1,563.68
 *     state.quoteBreakdown carried  Spigot (base mount) x 14 @ $60.67 = $849.38
 *     breakdown total               $2,413.06
 * The displayed total only sums the PER-SECTION subtotals, so the spigot line - which has no
 * section number - was invisible on screen. But it carried a real variantId (41519272853598)
 * and was pushed into state.cartItems, so the customer saw $1,563.68 and would have been
 * charged about $849 more at checkout. With a gate on section 3 it was 12 x $60.67 = $728.04.
 *
 * A SINGLE-section flat top job emits the same line at quantity 0, which is why this never
 * showed up until a multi-section plan. Blade is clean - no spigot line at all, and its
 * displayed total and breakdown agree exactly ($2,881.78 on the same test).
 *
 * NOT caused by the 2026-08-31 / 09-01 patches: reproduced identically on theme 141404799070
 * with none of them loaded - same 14 spigots, same $1,563.68 vs $2,413.06 split.
 *
 * FIX. On blade / flat top / PerfMesh, any spigot line is removed from state.quoteBreakdown
 * and from state.cartItems, the total is recomputed from what remains, and the breakdown is
 * re-rendered. This only ever REMOVES a charge for a part these fences do not use, so it can
 * only bring a quote down, and it brings the displayed total and the cart back into
 * agreement. Glass is untouched - it genuinely needs spigots.
 *
 * Shape follows cf-calc-fixes.js: IIFE, prototype flag, polled install with a try limit,
 * every wrapper in try/catch so it can never break the calculator.
 */
(function () {
  'use strict';

  if (!/(blade-fence-calculator|flat-top-fence-calculator|perfmesh-fence)/.test(location.pathname)) return;

  var TRIES = 0, MAX_TRIES = 200;

  function inst() { return window.glassCalculator || window.glassFencingCalculator || null; }
  function isSpigot(txt) { return /spigot/i.test(String(txt || '')); }

  function stripSpigots(fc) {
    try {
      if (!fc || !fc.state) return;
      var changed = false, i;

      var bd = fc.state.quoteBreakdown;
      if (Object.prototype.toString.call(bd) === '[object Array]') {
        for (i = bd.length - 1; i >= 0; i--) {
          if (!bd[i]) continue;
          if (isSpigot(bd[i].item) || isSpigot(bd[i].category)) { bd.splice(i, 1); changed = true; }
        }
      }

      var ci = fc.state.cartItems;
      if (Object.prototype.toString.call(ci) === '[object Array]') {
        for (i = ci.length - 1; i >= 0; i--) {
          if (ci[i] && isSpigot(ci[i].title || ci[i].name)) { ci.splice(i, 1); changed = true; }
        }
      }

      if (!changed) return;

      if (Object.prototype.toString.call(bd) === '[object Array]') {
        var sum = 0;
        for (i = 0; i < bd.length; i++) sum += Number(bd[i] && bd[i].totalPrice) || 0;
        fc.state.quote = Math.round(sum * 100) / 100;
      }
      try { fc.updateQuoteBreakdown(); } catch (e) {}
    } catch (e) {}
  }

  var timer = null;
  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { stripSpigots(inst()); }, 200);
  }

  function install() {
    var fc = inst();
    if (!fc || !fc.state) return false;
    var P = Object.getPrototypeOf(fc);
    if (!P || P.__cfNoSpigots) return true;

    // updateQuoteSummary rebuilds the breakdown, so strip after it. It is the only method
    // wrapped here and it is not called from updateQuoteBreakdown, so there is no recursion.
    if (typeof P.updateQuoteSummary === 'function') {
      var o = P.updateQuoteSummary;
      P.updateQuoteSummary = function () {
        var r = o.apply(this, arguments);
        try { stripSpigots(this); } catch (e) {}
        return r;
      };
    }

    try {
      var root = document.querySelector('.calculator-content') || document.body;
      if (window.MutationObserver) {
        new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
      }
    } catch (e) {}

    P.__cfNoSpigots = true;
    schedule();
    try { console.log('[cf-no-spigots] installed'); } catch (e) {}
    return true;
  }

  function tryInstall() {
    var done = false;
    try { done = install(); } catch (e) {}
    if (done) return;
    if (++TRIES < MAX_TRIES) setTimeout(tryInstall, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInstall);
  } else {
    tryInstall();
  }
})();
